
import { Component, Vue } from 'vue-property-decorator';
import ChannelSummary from './channel-summary.vue';
import ChannelDetails from './channel-details.vue';
import { iTimeParams } from '@/interface/exchange-code';
@Component({
  components: { ChannelSummary, ChannelDetails },
})
export default class ChannelExtension extends Vue {
  timeInfo: iTimeParams = {
    start: 0,
    end: 0,
  };
  dataChange({ start, end }: iTimeParams) {
    this.timeInfo.start = start;
    this.timeInfo.end = end;
  }
}
